export async function updateTipDineIn(restauId, tableId, tipInCents) {
    const database = window.customerApp.database();
    var updates = {};
    updates['summons/' + restauId + '/' + tableId + '/tip'] = tipInCents;
    updates['activeusers/' + restauId + '/' + tableId + '/tip'] = tipInCents;
    await database.ref().update(updates);
}
